
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/materialize",
      function () {
        return require("private-next-pages/sources/materialize.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/materialize"])
      });
    }
  